import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const apiKey = environment.city.apiKey;
  
  const modifiedReq = req.clone({
    setHeaders: {
      'ApiKey': apiKey ?? '',
      // 'UserId': userId ?? '',
    }
  });

  return next(modifiedReq);
};